import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { IcecontrolSettings } from 'projects/icemedx-lib/src/components/models/icesettings';
import { Iceutility } from '../../services/iceutility';
import { IcepanelComponent } from '../icepanel/icepanel.component';

@Component({
  selector: 'iceradiobutton',
  templateUrl: './iceradiobutton.component.html',
  styleUrls: ['./iceradiobutton.component.scss']
})
export class IceradiobuttonComponent implements OnInit {

  // Input Members
  @Input() id: string = "";
  @Input() ctrl: IcecontrolSettings = null;

  // Output Members
  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() buttonChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    @Inject(IcepanelComponent) private parent: IcepanelComponent) {
  }

  ngOnInit() {
  }

  private getOptions(): any {
    if (Iceutility.isdefined(this.ctrl)) {
      return this.ctrl.getOptions();
    }
    return [];
  }

  onClick(event) {
    event.buttonSettings = this.ctrl;
    if (this.parent && this.parent.buttonClick)
      this.parent.onButtonClick(event);
    else
      this.buttonClick.emit(event);
  }

  onChange(event) {
    event.buttonSettings = this.ctrl;
    if (event && Iceutility.isdefined(event.value) && this.ctrl.getFormControl()) {
      this.ctrl.getFormControl().setValue(event.value);
    }

    if (this.parent && this.parent.controlChange)
      this.parent.onControlChange(event);
    else
      this.buttonChange.emit(event);
  }
}
